(function () {
  'use strict';

  // Why is this here? Because hiding/showing mobile chrome/safari bar triggers a resize event
  // so we need to check for the actual window size change

  var width = jQuery(window).width();
  var height = jQuery(window).height();
  var checkResize = function () {
    var currentWidth = jQuery(window).width();
    var currentHeight = jQuery(window).height();
    if (currentWidth !== width || currentHeight !== height) {
      if (currentWidth !== width && window.dispatchEventType) {
        window.dispatchEventType(window, 'resize:width');
      }

      if (currentHeight !== height && window.dispatchEventType) {
        window.dispatchEventType(window, 'resize:height');
      }

      if (window.dispatchEventType) {
        window.dispatchEventType(window, 'resize:real');
      }

      jQuery(window).trigger('realResize');

      width = currentWidth;
      height = currentHeight;
    }
  };

  jQuery(window).resize(checkResize);
})();
